import React from 'react';
import { colors } from '../theme';
import IProps from './interface';

const ContactDataValidationIcon = ({
  color = colors.black,
  className,
  onClick,
  size = 32,
}: IProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        d="M16.1217 14.244C17.2934 15.4156 17.2934 17.3153 16.1217 18.4869C14.95 19.6586 13.0504 19.6586 11.8787 18.4869C10.7071 17.3153 10.7071 15.4156 11.8787 14.244C13.0504 13.0723 14.95 13.0723 16.1217 14.244"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5555 25.3345C19.0034 23.8678 17.602 22.8184 15.9419 22.8184H12.0589C10.3988 22.8184 8.99735 23.8678 8.44531 25.3345"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.9997 13.3335C21.0542 13.3335 18.666 10.9453 18.666 7.99975C18.666 5.05419 21.0542 2.66602 23.9997 2.66602C26.9466 2.66602 29.3335 5.05419 29.3335 7.99975C29.3335 10.9453 26.9466 13.3335 23.9997 13.3335"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.3706 6.81445L23.4077 9.77734L21.6289 7.99988"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6672 6.66602H7.99975C5.05419 6.66602 2.66602 9.05419 2.66602 11.9997V24.0006C2.66602 26.9462 5.05419 29.3344 7.99975 29.3344H20.0006C22.9462 29.3344 25.3344 26.9462 25.3344 24.0006V13.3332"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ContactDataValidationIcon;
